// DEPENDENCIES
import React from 'react';
// COMPONENTS
import { Link } from 'react-router-dom';
// ICONS
import { AiOutlineLoading } from 'react-icons/ai';
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';

const Button = (props) => {

    const sizes = {
        lg: "--lg",
        md: "--md",
        sm: "--sm",
        xs: "--xs",
        xxs: "--xxs",
    }

    const buttonStyle = {
        ...props.style,
        cursor: props.loading ? "wait" : (props.style && props.style.cursor) || "pointer",
    };

    return (
        <>
            {
                props.to ?
                    <Link
                        to={props.to}
                        className={`button${props.size ? sizes[props.size] : ""} ${props.className ? props.className : ""} ${props.uppercaseText ? "uppercase" : ""}`}
                        style={buttonStyle}
                        disabled={props.disabled || props.loading}
                        target={props.openInNewTab && "_blank"}
                        rel={props.openInNewTab ? "noopener noreferrer" : undefined}
                    >
                        {props.iconLeft}
                        {
                            props.loading ?
                                <AiOutlineLoading className="loading-indicator rotating" size={22} /> : props.text
                        }
                        {props.iconRight}
                    </Link>
                    :
                    <>
                        <button
                            type={props.type ? props.type : "button"}
                            onClick={props.onClick ? props.onClick : () => { }}
                            className={`button${props.size ? sizes[props.size] : ""} ${props.className ? props.className : ""} ${props.uppercaseText ? "uppercase" : ""}`}
                            style={buttonStyle}
                            disabled={props.disabled || props.loading}
                        >
                            {props.iconLeft}
                            {
                                props.loading ?
                                    <AiOutlineLoading className="loading-indicator rotating" size={22} /> : props.text
                            }
                            {props.iconRight}
                        </button>
                        {
                            props.buttonSubActions &&
                            <CustomBlock className={`button-sub-actions-container ${props.subActionsVisible ? "visible" : "hidden"}`}>
                                {props.buttonSubActions}
                            </CustomBlock>
                        }
                    </>

            }
        </>
    );
}

export default Button;
